import React, { useState } from "react";
import PrimaryLinkButton from "../ui/PrimaryLinkButton";

const previewItems = [
  {
    label: "Weekstructuur",
    title: "Trainingsweek overzicht",
    description:
      "Een duidelijk overzicht van de week, zodat je weet wat je traint en waarom.",
    imageSrc: "/img/program-preview/week-overview.png",
    imageAlt: "Voorbeeld van een trainingsweek overzicht",
  },
  {
    label: "Trainingsdag",
    title: "Voorbeeld trainingsdag",
    description:
      "Opbouw met warming-up, hoofdwerk, conditie en ruimte voor notities.",
    imageSrc: "/img/program-preview/training-day.png",
    imageAlt: "Voorbeeld van een trainingsdag uit het programma",
  },
  {
    label: "Fundament",
    title: "Militair voorbereidingshandboek",
    description:
      "Uitleg over voorbereiding, belastbaarheid, herstel en keuzes in training.",
    imageSrc: "/img/program-preview/handbook-page.png",
    imageAlt: "Voorbeeldpagina uit het militaire voorbereidingshandboek",
  },
  {
    label: "Meten",
    title: "Startmeting en voortgang",
    description:
      "Ruimte om scores, progressie en aandachtspunten bij te houden.",
    imageSrc: "/img/program-preview/test-scores.png",
    imageAlt: "Voorbeeld van startmeting en voortgangsregistratie",
  },
  {
    label: "Herstel",
    title: "Belastbaarheid en herstel",
    description:
      "Niet alleen trainen, maar ook leren wanneer je moet bijsturen.",
    imageSrc: "/img/program-preview/recovery-notes.png",
    imageAlt: "Voorbeeld van herstelnotities en belastbaarheidsregistratie",
  },
];

const PreviewImage = ({ item }) => {
  const [hasError, setHasError] = useState(false);

  return (
    <div className="relative aspect-[4/3] overflow-hidden rounded-xl border border-mmBorder bg-mmPage">
      {hasError ? (
        <div className="absolute inset-0 flex items-center justify-center bg-[linear-gradient(135deg,rgba(255,255,255,0.03),rgba(255,255,255,0.01))] px-6 text-center">
          <p className="font-display text-xs uppercase tracking-[0.18em] text-mmTextMuted">
            Preview volgt
          </p>
        </div>
      ) : (
        <img
          src={item.imageSrc}
          alt={item.imageAlt}
          className="h-full w-full object-contain"
          loading="lazy"
          decoding="async"
          onError={() => setHasError(true)}
        />
      )}
    </div>
  );
};

const ProgramPreviewCarousel = () => {
  return (
    <section className="w-full border-t border-mmBorder bg-mmPage py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-10 lg:px-20">
        <div className="max-w-3xl">
          <p className="mb-3 font-display text-sm uppercase tracking-[0.18em] text-mmAccent md:text-base">
            Programma preview
          </p>
          <h2 className="mm-h2 mb-4 text-mmText">Een kijkje in het programma</h2>
          <p className="text-base leading-relaxed text-mmTextMuted md:text-lg">
            Je hoeft niet blind te starten. Hieronder zie je voorbeelden van hoe
            een trainingsweek, trainingsdag en het militaire fundament zijn
            opgebouwd.
          </p>
        </div>

        <div className="relative -mx-5 mt-10 sm:-mx-10 lg:-mx-20">
          <div className="overflow-x-auto px-5 pb-3 scroll-smooth snap-x snap-mandatory [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:px-10 lg:px-20">
            <div className="flex min-w-max gap-5">
              {previewItems.map((item) => (
                <article
                  key={item.title}
                  className="mm-card flex w-[290px] shrink-0 snap-start flex-col p-5 sm:w-[320px]"
                >
                  <PreviewImage item={item} />
                  <div className="mt-5 flex flex-1 flex-col">
                    <p className="mb-2 font-display text-xs uppercase tracking-[0.18em] text-mmAccent">
                      {item.label}
                    </p>
                    <h3 className="font-display text-lg uppercase tracking-widest text-mmText">
                      {item.title}
                    </h3>
                    <p className="mt-3 text-sm leading-relaxed text-mmTextMuted">
                      {item.description}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>
          <div
            className="pointer-events-none absolute inset-y-0 right-0 z-10 w-12 bg-gradient-to-l from-mmPage via-mmPage/80 to-transparent sm:w-14"
            aria-hidden="true"
          />
        </div>

        <div className="mt-8">
          <PrimaryLinkButton to="/program#routeadvies" className="inline-flex">
            Bekijk welke route past
          </PrimaryLinkButton>
        </div>
      </div>
    </section>
  );
};

export default ProgramPreviewCarousel;
